










import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import applyContainer from "@components/vat/apply/applyContainer.vue";
import jump from "@lib/mixins/jump"
const indexModule = namespace("index");
@Component({
  components: {
    applyContainer
  },
  mixins: [jump]
})
export default class VatNoApply extends Vue {
  @indexModule.Getter("accountInfo")
  private accountInfo: any;
  @indexModule.Action("chargeCIP")
  private chargeCIP: any;
  private async apply() {
    // if (true) {
    //   this.$jump({name: 'vatTaxFilingApply'})
    // }
    this.chargeCIP(()=>{
      this.$jump({name: 'vatTaxFilingApply'})
    })
  }
  private async mounted() {}
}
